module.exports = __webpack_public_path__ + "img/431.8f1a32cc.png";